import {
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  Radio,
  Row,
  Select,
  Spin,
  Tooltip,
  message,
} from 'antd';
import dayjs from 'dayjs';
import { useEffect,useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { ReactComponent as Back } from '../../Images/Back.svg';
import { InfoCircleOutlined, PlusOutlined } from '@ant-design/icons';
import AutoOpenSelect from '../SelectComponent/AutoOpenSelect';
import {
  fetchDieProfileDropdown,
  resetCurrentDieProfilePage,
  resetDieProfileData,
  resetDieProfileList,
} from './../../slices/die-profile';

import {
  resetCurrentDieSizePage,
  resetDieSizeList,
  fetchDieSizeDropdown,
} from './../../slices/die-size';
import {
  fetchVendorDropdown,
  resetCurrentVendorPage,
  resetVendorList,
} from '../../slices/vendor';
import {
  fetchBlosterDropdown,
  resetCurrentBlosterPage,
  resetBlosterList,
} from '../../slices/bolster';
import {
  fetchFirstWeightEntryById,
  fetchFirstWeightEntryDetails,
  updateFirstWeightEntry,
} from './../../slices/first-weight-entry';
import {
  fetchDiePressDropdown,
  resetDiePressList,
  resetCurrentDiePressPage,
} from './../../slices/die-press';


import { createNumberValidationRule } from '../../utils/CreateNumberValidationRule';
import { debounce } from 'lodash';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import CameraCapture from './CameraCapture';
import { fetchVehicleTypeList, resetVehicleTypeList } from '../../slices/vehicle-type';
import { fetchMaterialList, resetMaterialList } from '../../slices/material';
import { fetchTransporterList, resetTransporterList } from '../../slices/transporter';
import { fetchPurchaserList, resetPurchaserList } from '../../slices/purchaser';
import { fetchSellerList, resetSellerList } from '../../slices/seller';
const { Option } = Select;

function EditFirstWeightEntry() {
  const [form] = Form.useForm();
  let navigate = useNavigate();
  const { id } = useParams();
  const [dieType, setDieType] = useState(null);
  const [searchGroup, setSearchGroup] = useState('');
  const dispatch = useDispatch();
  const [btnLoading, setBtnLoading] = useState(false);
  const [selectedPress, setSelectedPress] = useState([]);
  const [selectedSize, setSelectedSize] = useState(null);
  const [searchDieProfile, setSearchDieProfile] = useState('');
  const [searchDieSize, setSearchDieSize] = useState('');
  const [searchDeveloper, setSearchDeveloper] = useState('');
  const [searchBloster, setSearchBloster] = useState('');
  const [showDropdownLoader, setShowDropdownLoader] = useState(false);
    const [isCheckboxDisabledActive, setIsCheckboxDisabledActive] = useState(false);
    const [forceOpen, setForceOpen] = useState(false);
  const [runUnderDeviation, setRunUnderDeviation] =
    useState('under development');
  const [runUnderDeviationReason, setRunUnderDeviationReason] = useState('');
  const {
    list: diePressList,
    list: diePressDropdown,
    loading: diePressLoading,
    currentpage: diePressCurrentPage,
    hasMore: diePressHasMore,
  } = useSelector(state => state.diePress);
  const [toolData, setToolData] = useState(); // Default value
  const [searchDiePress, setSearchDiePress] = useState('');
  const {
    list: dieProfileList,
    list: dieProfileDropdown,
    loading: dieProfileLoading,
    currentPage: dieProfileCurrentPage,
    hasMore: dieProfileHasMore,
  } = useSelector(state => state.dieProfile);
  const {
    list: dieSizeList,
    list: dieSizeDropdown,
    loading: dieSizeLoading,
    currentPage: dieSizeCurrentPage,
    hasMore: dieSizeHasMore,
  } = useSelector(state => state.diesize);

  const {
    list: developerList,
    list: vendorDropdown,
    loading: developerLoading,
    currentPage: developerCurrentPage,
    hasMore: developerHasMore,
  } = useSelector(state => state.vendor);
  const {
    list: blosterList,
    list: blosterDropdown,
    loading: blosterLoading,
    currentPage: blosterCurrentPage,
    hasMore: blosterHasMore,
  } = useSelector(state => state.bloster);
  const {
    list: vehicleTypeDropdown,
    loading: vehicleTypeLoading,
    currentPage: vehicleTypeCurrentPage,
    hasMore: vehicleTypeHasMore,
  } = useSelector(state => state.vehicleType);
  const {
    list: materialDropdown,
    loading: materialLoading,
    currentPage: materialCurrentPage,
    hasMore: materialHasMore,
  } = useSelector(state => state.material);
  const {
    list: partyNameDropdown,
    loading: partyNameLoading,
    currentPage: partyNameCurrentPage,
    hasMore: partyNameHasMore,
  } = useSelector(state => state.transporter);
  const {
    list: purchaserDropdown,
    loading: purchaserLoading,
    currentPage: purchaserCurrentPage,
    hasMore: purchaserHasMore,
  } = useSelector(state => state.purchaser);
  const {
    list: sellerDropdown,
    loading: sellerLoading,
    currentPage: sellerCurrentPage,
    hasMore: sellerHasMore,
  } = useSelector(state => state.seller);
  const [isOrderDateRequired, setIsOrderDateRequired] = useState(false);
  const [isCheckboxDisabled, setIsCheckboxDisabled] = useState(false);
  const [isReceivedDateRequired, setIsReceivedDateRequired] = useState(false);
  const [selectedSolidOption, setSelectedSolidOption] = useState(null);
  const [selectHollowOption, setSelectHollowOption] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
   const [selectedWeightForOption, setSelectedWeightForOption] = useState(null);
    const [selectedWeightAutomaticOption, setSelectedWeightAutomaticOption] = useState(null);
    const [selectedTotalCopy, setSelectedTotalCopy] = useState(null);
  const [selectedVendor, setselectVendor] = useState(null);
  const [selectedBloster, setSelectBloster] = useState(null);
  const [selectedDiePress, setSelectDiePress] = useState(null);
  const [selectSemiHollowOption, setSelectSemiHollowOption] = useState(null);
  const [selectedVehicleType, setSelectedVehicleType] = useState(null);
  const [selectedVehicleNo, setSelectedVehicleNo] = useState(null);
  const [selectedPartyName, setSelectedPartyName] = useState(null);
  const [selectedSerialNo, setSelectedSerialNo] = useState(null);
  const [selectedMaterial, setSelectedMaterial] = useState(null);
  const [selectedPurchaser, setSelectedPurchaser] = useState(null);
  const [selectedSeller, setSelectedSeller] = useState(null);
  const [searchVehicleType, setSearchVehicleType] = useState('');
  const [searchPartyName, setSearchPartyName] = useState('');
  const [searchMaterial, setSearchMaterial] = useState('');
  const [searchPurchaser, setSearchPurchaser] = useState('');
  const [searchSeller, setSearchSeller] = useState('');
  const weightForType = [
    { id: 'weight_for_gross_weight', name: 'Gross Weight' },
    { id: 'weight_for_tare_weight', name: 'Tare Weight' },
    
  ];
  const weightAutomaticType = [
    { id: 'Yes', name: 'Yes' },
    { id: 'No', name: 'No' },
    
  ];
  const totalCopyList = [
    { id: '1', name: '1' },
    { id: '2', name: '2' },
    { id: '3', name: '3' },
    { id: '4', name: '4' },
    { id: '5', name: '5' },
    
  ];

  const getClassNameDieProfile = value => {
    const selected = dieProfileDropdown.find(
      item => item.id === selectedCity,
    );
    return selected && selected.deleted === 1
      ? 'inactive-option'
      : 'active-option';
  };

  const getClassNamePress = value => {
    const selected = diePressDropdown.find(
      item => item.id === selectedDiePress,
    );
    return selected && selected.deleted === 1
      ? 'inactive-option'
      : 'active-option';
  };

  const getClassNameVendor = value => {
    const selected = vendorDropdown.find(item => item.id === selectedVendor);
    return selected && selected.deleted === 1
      ? 'inactive-option'
      : 'active-option';
  };
  const getClassNameVehicleType = () => {
    const selected = dieProfileDropdown.find(
      item => item.id === selectedVehicleType?.value,
    );
    return selected && selected.deleted === 1
      ? 'inactive-option'
      : 'active-option';
  };
  const getClassNameVehicleNo = () => {
    const selected = dieProfileDropdown.find(
      item => item.id === selectedVehicleNo?.value,
    );
    return selected && selected.deleted === 1
      ? 'inactive-option'
      : 'active-option';
  };
  const getClassNamePartyName = () => {
    const selected = dieProfileDropdown.find(
      item => item.id === selectedPartyName?.value,
    );
    return selected && selected.deleted === 1
      ? 'inactive-option'
      : 'active-option';
  };
  const getClassNameSerialNo = () => {
    const selected = dieProfileDropdown.find(
      item => item.id === selectedSerialNo?.value,
    );
    return selected && selected.deleted === 1
      ? 'inactive-option'
      : 'active-option';
  };
  const getClassNameMaterial = () => {
    const selected = dieProfileDropdown.find(
      item => item.id === selectedMaterial?.value,
    );
    return selected && selected.deleted === 1
      ? 'inactive-option'
      : 'active-option';
  };
  const getClassNamePurchaser = () => {
    const selected = dieProfileDropdown.find(
      item => item.id === selectedPurchaser?.value,
    );
    return selected && selected.deleted === 1
      ? 'inactive-option'
      : 'active-option';
  };
  const getClassNameSeller = () => {
    const selected = dieProfileDropdown.find(
      item => item.id === selectedSeller?.value,
    );
    return selected && selected.deleted === 1
      ? 'inactive-option'
      : 'active-option';
  };
  const handleWeightForOptionChange = value => {
    setSelectedWeightForOption(value);

    
  };
  const handleWeightAutomaticOptionChange = value => {
    setSelectedWeightAutomaticOption(value);

    form.setFieldsValue({
        weight: undefined,
        
      });
  };
  const handleTotalCopyChange = value => {
    setSelectedTotalCopy(value);

    form.setFieldsValue({
      backer_number: undefined,
      diameter: undefined,
      thickness: undefined,
    });
  };

  const handleSearchWeightFor = value => {
    setSelectedWeightForOption(value);
  };
  const handleSearchWeightAutomatic = value => {
    setSelectedWeightAutomaticOption(value);
  };
  const handleSearchTotalCopy = value => {
    setSelectedTotalCopy(value);
  };


  const handleDeviationChange = e => {
    const value = e.target.value;
    setRunUnderDeviation(value);
    if (value !== 'inactive') {
      setRunUnderDeviationReason('');
    }
    // If "Active" is selected, make received_date required
    if (value === 'active') {
      setIsReceivedDateRequired(true);
    } else {
      setIsReceivedDateRequired(false);
      // If moving away from Active, clear received_date
      if (form.getFieldValue('received_date')) {
        form.setFieldsValue({ received_date: null });
      }
    }
    // If "Active" is selected and no received_date, optionally focus the field (UX improvement)
    if (value === 'active' && !form.getFieldValue('received_date')) {
      // Optionally focus the field
    }
  }

  const handleHoolowOptionChange = value => {
    setSelectHollowOption(value);
    form.setFieldsValue({
      backer_number: undefined,
      diameter: undefined,
      thickness: undefined,
    });
  };

  const handleSearchHollowDie = value => {
    setSelectHollowOption(value);
  };
  const handleSearchDiePress = value => {
    setSearchDiePress(value);
    if (value) {
      setSearchDiePress(value);
      dispatch(resetDiePressList());
      dispatch(fetchDiePressDropdown({ page: 1, pagesize: 10, search: value }));
    } else {
      setSearchDiePress('');
      dispatch(resetDiePressList());
      dispatch(resetCurrentDiePressPage());
      dispatch(fetchDiePressDropdown({ page: 1, pagesize: 10 }));
    }
  };
  const handleChangeDiePress = value => {
    setSearchDiePress(value);
    setSelectDiePress(value);
  };
  const onScrollDiePress = async event => {
    const target = event.target;
    if (
      !diePressLoading &&
      diePressHasMore &&
      target.scrollTop + target.offsetHeight === target.scrollHeight
    ) {
      dispatch(
        fetchDiePressDropdown({ page: diePressCurrentPage, pagesize: 10 }),
      );
    }
  };
  const handleReasonChange = e => {
    const value = e.target.value;
    setRunUnderDeviationReason(e.target.value);
    if (value !== 'other') {
      form.setFieldsValue({ run_under_deviation_reason: value });
    }
  };

  const getClassName = () => {
    const selected = dieSizeDropdown.find(item => item.id === selectedSize);
    return selected && selected.deleted === 1
      ? 'inactive-option'
      : 'active-option';
  };

  const handleDieProfileChange = (selected, value) => {
    setSelectedCity(value);
    if (!selected) {
      form.setFieldsValue({
        tool_number: null,
        die_type: null,
        total_running_qty: null,
        total_running_ton: null,
        wt_kg_p_mt: null,
      });
      setSearchGroup(null); // Reset searchGroup state to clear the selected value
      return;
    }
    try {
      dispatch(fetchFirstWeightEntryDetails(selected.label))
        .unwrap()
        .then(response => {
          if (response.success) {
            const fetchedDieType = response.data.die_type;
            setDieType(fetchedDieType);
            form.setFieldsValue({
              tool_number: response.data.tool_number,
              die_type: fetchedDieType,
              total_running_qty: response.data.total_running_qty,
              total_running_ton: response.data.total_running_ton,
              wt_kg_p_mt:
                response.data.tool_number === '1'
                  ? response.data.current_kg
                  : 0,
            });
          }
        })
        .catch(error => {
          console.error('');
        });
    } catch (error) {
      console.error('');
    }
  };
  const handleSearchDieGroup = value => {
    setSearchGroup(value);
    if (value) {
      dispatch(fetchFirstWeightEntryDetails({ page: 1, pagesize: 1000, search: value }));
    } else {
      dispatch(fetchFirstWeightEntryDetails({ page: 1, pagesize: 10 }));
    }
  };

  const handleFormChange = changedValues => {
    if ('received_date' in changedValues) {
      const orderDate = changedValues.received_date;
      if (orderDate) {
        form.setFieldsValue({ is_active: true });
        setIsCheckboxDisabled(true); // Check the checkbox
      } else {
        form.setFieldsValue({ is_active: false }); // Enable the checkbox if order_date is cleared
        setIsCheckboxDisabled(false);
      }
    }
  
 
  };
 
  const handleVehicleTypeChange = (selected, value) => {
    setSelectedVehicleType(value);
    // setSearchVehicleType(value);
  
   
  };
  const handleClearVehicleType = () => {
    setSearchVehicleType(null);
    setSelectedVehicleType(null);
    form.setFieldsValue({ vehicle_type: null });
    dispatch(
      fetchVehicleTypeList({
        page: 1,
        pagesize: 100,
      })
    );
  };


  const handlePartyNameChange = (selected, value) => {
    setSelectedPartyName(value);
 
   
  };
  const handleClearPartyName = () => {
    setSearchPartyName(null);
    setSelectedPartyName(null);
    form.setFieldsValue({ party_name: null });
    dispatch(resetTransporterList());
    dispatch(
      fetchTransporterList({
        page: 1,
        pagesize: 100,
      })
    );
  };

 
  const handleMaterialChange = (selected, value) => {
    setSelectedMaterial(value);
 
   
  };
  const handleClearMaterial = () => {
    setSearchMaterial(null);
    setSelectedMaterial(null);
    form.setFieldsValue({ material: null });
    dispatch(resetMaterialList());
    dispatch(
      fetchMaterialList({
        page: 1,
        pagesize: 100,
      })
    );
  };
  const handlePurchaserChange = (selected, value) => {
    setSelectedPurchaser(value);
  };
  const handleClearPurchaser = () => {
    setSearchPurchaser(null);
    setSelectedPurchaser(null);
    form.setFieldsValue({ purchaser: null });
    dispatch(resetPurchaserList());
    dispatch(
      fetchPurchaserList({
        page: 1,
        pagesize: 100,
      })
    );
  };
  const handleSellerChange = (selected, value) => {
    setSelectedSeller(value); 
  };
  const handleClearSeller = () => {
    setSearchSeller(null);
    setSelectedSeller(null);
    form.setFieldsValue({ seller: null });
    dispatch(resetSellerList());
    dispatch(
      fetchSellerList({
        page: 1,
        pagesize: 100,
      })
    );
  };
  const debouncedSearchDieProfile = debounce((value, dispatch) => {
    dispatch(resetDieProfileData()); // Reset the list when searching
    dispatch(
      fetchDieProfileDropdown({
        page: 1,
        pagesize: 50,
        search: value || '',
      }),
    );
  }, 300);
  const handleSearchCity = value => {
    setSearchDieProfile(value);

    if (value) {
      debouncedSearchDieProfile(value, dispatch);
    } else {
      dispatch(resetDieProfileData());
      dispatch(fetchDieProfileDropdown({ page: 1, pagesize: 50 }));
    }
  };
  const handleSearchSerialNo = value => {
    setSearchDieProfile(value);

    if (value) {
      debouncedSearchDieProfile(value, dispatch);
    } else {
      dispatch(resetDieProfileData());
      dispatch(fetchDieProfileDropdown({ page: 1, pagesize: 50 }));
    }
  };
  const handleSearchVehicleType = value => {
    setSearchDieProfile(value);

    if (value) {
      debouncedSearchDieProfile(value, dispatch);
    } else {
      dispatch(resetDieProfileData());
      dispatch(fetchDieProfileDropdown({ page: 1, pagesize: 50 }));
    }
  };
  const debounceVehicleTypeSearch = useMemo(
    () =>
      debounce((value) => {
        dispatch(resetVehicleTypeList());
        dispatch(fetchVehicleTypeList({
          page: 1,
          pagesize: 100,
          ...(value && { search: value }),
        }));
        setSearchVehicleType(value)
      }, 1000),
    [dispatch]
  );
  const debounceMaterialSearch = useMemo(
    () =>
      debounce((value) => {
        dispatch(resetMaterialList());
        dispatch(fetchMaterialList({
          page: 1,
          pagesize: 100,
          ...(value && { search: value }),
        }));
        setSearchMaterial(value)
      }, 1000),
    [dispatch]
  );
  const debouncePurchaserSearch = useMemo(
    () =>
      debounce((value) => {
        dispatch(resetPurchaserList());
        dispatch(fetchPurchaserList({
          page: 1,
          pagesize: 100,
          ...(value && { search: value }),
        }));
        setSearchPurchaser(value)
      }, 1000),
    [dispatch]
  );
  const debounceSellerSearch = useMemo(
    () =>
      debounce((value) => {
        dispatch(resetSellerList());
        dispatch(fetchSellerList({
          page: 1,
          pagesize: 100,
          ...(value && { search: value }),
        }));
        setSearchSeller(value)
      }, 1000),
    [dispatch]
  );
  const debouncePartyNameSearch = useMemo(
    () =>
      debounce((value) => {
        dispatch(resetTransporterList())
        dispatch(fetchTransporterList({
          page: 1,
          pagesize: 100,
          ...(value && { search: value }),
        }));
        setSearchPartyName(value)
      }, 1000),
    [dispatch]
  );

    const onScrollVehicleNo = event => {
      const target = event.target;
  
      if (
        !dieProfileLoading &&
        dieProfileHasMore &&
        target.scrollHeight - target.scrollTop - target.clientHeight < 50
      ) {
        const nextPage = dieProfileCurrentPage + 1;
  
        dispatch(
          fetchDieProfileDropdown({
            page: nextPage,
            pagesize: 50,
            search: searchDieProfile || '',
          }),
        );
      }
    };
    const onScrollVehicleType = event => {
      const target = event.target;
  
      if (
        !vehicleTypeLoading &&
        vehicleTypeHasMore &&
        target.scrollTop + target.offsetHeight === target.scrollHeight
        // target.scrollHeight - target.scrollTop - target.clientHeight < 50
      ) {
        // const nextPage = vehicleTypeCurrentPage + 1;
  
        dispatch(
          fetchVehicleTypeList({
            page: vehicleTypeCurrentPage + 1,
            pagesize: 100,
            search: searchVehicleType || '',
            // ...(searchVehicleType && { search: searchVehicleType }),
          }),
        );
      }
    };
    const onScrollSeller = event => {
      const target = event.target;
  
      if (
        !sellerLoading &&
        sellerHasMore &&
        target.scrollTop + target.offsetHeight === target.scrollHeight
      
      ) {
      
  
        dispatch(
          fetchSellerList({
            page: sellerCurrentPage + 1,
            pagesize: 100,
            search: searchSeller || '',
        
          }),
        );
      }
    };
    const onScrollPurchaser = event => {
      const target = event.target;
  
      if (
        !purchaserLoading &&
        purchaserHasMore &&
        target.scrollTop + target.offsetHeight === target.scrollHeight
        // target.scrollHeight - target.scrollTop - target.clientHeight < 50
      ) {
        // const nextPage = vehicleTypeCurrentPage + 1;
  
        dispatch(
          fetchPurchaserList({
            page: purchaserCurrentPage + 1,
            pagesize: 100,
            search: searchPurchaser || '',
            // ...(searchVehicleType && { search: searchVehicleType }),
          }),
        );
      }
    };
    const onScrollMaterial = event => {
      const target = event.target;
  
      if (
        !materialLoading &&
        materialHasMore &&
        target.scrollTop + target.offsetHeight === target.scrollHeight
        // target.scrollHeight - target.scrollTop - target.clientHeight < 50
      ) {
        // const nextPage = vehicleTypeCurrentPage + 1;
  
        dispatch(
          fetchMaterialList({
            page: materialCurrentPage + 1,
            pagesize: 100,
            search: searchMaterial || '',
            // ...(searchVehicleType && { search: searchVehicleType }),
          }),
        );
      }
    };
    const onScrollPartyName = event => {
      const target = event.target;
  
      if (
        !partyNameLoading &&
        partyNameHasMore &&
        target.scrollTop + target.offsetHeight === target.scrollHeight
        // target.scrollHeight - target.scrollTop - target.clientHeight < 50
      ) {
        // const nextPage = vehicleTypeCurrentPage + 1;
  
        dispatch(
          fetchTransporterList({
            page: partyNameCurrentPage + 1,
            pagesize: 100,
            search: searchPartyName || '',
            // ...(searchVehicleType && { search: searchVehicleType }),
          }),
        );
      }
    };
 

  useEffect(() => {

    const fetchDieTool = async () => {
      try {
        dispatch(fetchFirstWeightEntryById(id))
         .unwrap()
          .then(response => {
          
            if (response.success) {
              const transporter = response.data;
           
             console.log("transporter",transporter);

              form.setFieldsValue({
                id: transporter?.id,
                cash_party_name: transporter?.cash_party_name,
                date_time_first: transporter?.date_time_first,
                date_time_second: transporter?.date_time_second,
                gross_weight: transporter?.gross_weight,
                // material_name: transporter?.material_name,
                material: transporter?.material_name,
                mound: transporter?.mound,
                net_weight: transporter?.net_weight,
                party_mobile_no: transporter?.party_mobile_no,
                // party_name_display: transporter?.party_name_display,
                party_name: transporter?.party_name_display,
                // purchaser_name: transporter?.purchaser_name,
                // seller_name: transporter?.seller_name,
                purchaser: transporter?.purchaser_name,
                seller: transporter?.seller_name,
                serial_no: transporter?.serial_no,
                tare_weight: transporter?.tare_weight,
                total_copy: transporter?.total_copy,
                vehicle_no: transporter?.vehicle_no,
                vehicle_type: transporter?.vehicle_type_name,
                weight: transporter?.weight,
                weight_automatic: transporter?.weight_automatic,
                weight_for: transporter?.weight_for==="gross_weight"?"Gross Weight":"Tare Weight",
                // created_by: transporter?.created_by,
                // created_by_name: transporter?.created_by_name,
                // updated_by: transporter?.updated_by,
                // updated_by_name: transporter?.updated_by_name,
                // deleted_by: transporter?.deleted_by,
                // created_at: transporter?.created_at,
                // updated_at: transporter?.updated_at,
                // deleted_at: transporter?.deleted_at,
                // deleted: transporter?.deleted,
              });
              
       

            // setSelectSendSmsTypeOption(transporter?.send_sms_type);
            // setSelectedBalanceTypeOption(transporter?.balance_type);
            }
          })
          .catch(error => {
            console.error('');
          });
      } catch (error) {
        console.error('');
      }
    };
    fetchDieTool();
  }, [id, form]);

  const onScrollDieSize = async event => {
    const target = event.target;
    if (
      !dieSizeLoading &&
      dieSizeHasMore &&
      target.scrollTop + target.offsetHeight === target.scrollHeight
    ) {
      dispatch(fetchDieSizeDropdown({ page: dieSizeCurrentPage, pagesize: 10 }));
    }
  };
  const onScrollDeveloper = async event => {
    const target = event.target;
    if (
      !developerLoading &&
      developerHasMore &&
      target.scrollTop + target.offsetHeight === target.scrollHeight
    ) {
      dispatch(fetchVendorDropdown({ page: developerCurrentPage, pagesize: 10 }));
    }
  };

  const onScrollBloster = async event => {
    const target = event.target;
    if (
      !blosterLoading &&
      blosterHasMore &&
      target.scrollTop + target.offsetHeight === target.scrollHeight
    ) {
      dispatch(fetchBlosterDropdown({ page: blosterCurrentPage, pagesize: 10 }));
    }
  };

  useEffect(() => {
    dispatch(resetTransporterList());
    dispatch(resetMaterialList());
    dispatch(resetSellerList());
    dispatch(resetPurchaserList());
    dispatch(resetVehicleTypeList());
 
    dispatch(fetchVehicleTypeList({ page: 1, pagesize: 100 }));
    dispatch(fetchMaterialList({ page: 1, pagesize: 100 }));
    dispatch(fetchTransporterList({ page: 1, pagesize: 100 }));
    dispatch(fetchPurchaserList({ page: 1, pagesize: 100 }));
    dispatch(fetchSellerList({ page: 1, pagesize: 100 }));
  }, []);

  const handleReceivedDateChange = (date, dateString) => {
    form.setFieldsValue({ received_date: date });
    if (date) {
      setRunUnderDeviation('active');
      setIsReceivedDateRequired(true);
      form.setFieldsValue({ run_under_deviation: 'active', is_active: true });
    } else {
      setRunUnderDeviation('under development');
      setIsReceivedDateRequired(false);
      form.setFieldsValue({ run_under_deviation: 'under development', is_active: false });
    }
  };

  const handleOrderDateChange = (date, dateString) => {
    form.setFieldsValue({ order_date: date });
  };

  const handleFinish = values => {
    setBtnLoading(true);
    const formattedValues = {
      ...values,
      order_date: values.order_date.format('YYYY-MM-DD'),
      received_date: values.received_date
        ? values.received_date.format('YYYY-MM-DD')
        : null,
    };
    values = formattedValues;

    dispatch(updateFirstWeightEntry({ id: id, values }))
      .unwrap()
      .then(result => {
        setBtnLoading(false);
        if (result.success) {
          message.success('Die Tool Updated Successfully!');
          navigate('/die-tool');
        }
      })
      .catch(error => {
        setBtnLoading(false);
        if (typeof error === 'object' && error !== null) {
          const messages = [];
          for (const key in error) {
            if (Array.isArray(error[key])) {
              messages.push(`${key}: ${error[key].join(', ')}`);
            }
          }

          if (messages.length > 0) {
            message.error(messages.join('; '));
          } else {
            message.error('An unknown error occurred.');
          }
        } else if (typeof error === 'string') {
          message.error(error); // Handle string error
        } else if (error instanceof Error) {
          message.error(error.message); // Handle Error object
        } else {
          message.error('An unknown error occurred.');
        }
      });
  };

  const onFinishFailed = errorInfo => { };

  const handleFieldChange = () => {
    const rackNo = form.getFieldValue('rac_no') || '';
    const rowNo = form.getFieldValue('row_no') || '';
    const columnNo = form.getFieldValue('column_no') || '';
    const dieLocation = `${rackNo} / ${rowNo} / ${columnNo}`;
    form.setFieldsValue({ die_location: dieLocation });
  };

  return (
    <>
      <div className="sticyaction">
        <Row
          className="pagenamerow mb-0"
          justify="space-between"
          align="middle"
        >
          <Col>
            <h2 style={{ margin: 0 }}>Edit First Weight Entry</h2>
            <div className="bredcrumbwrp">
              <Link onClick={() => navigate(-1)} className="back">
                <Back /> BACK
              </Link>
              <Breadcrumb
                items={[
                  { title: <Link to="/first-weight-entry-list">First Weight Entry List</Link> },
                  { title: 'Edit First Weight Entry' },
                ]}
              />
            </div>
          </Col>
        </Row>
      </div>
      <div className="formwrapper">
      <Form
          layout="vertical"
          onValuesChange={handleFormChange}
          form={form}
          initialValues={{
            is_active: true,
         
          }}
          onFinish={handleFinish}
          autoComplete="off"
        >
          <div className="formsection">
            <Row gutter={16}>
            <Col xs={12} sm={8} xl={6} xxl={3}>
                  <Form.Item
                    name="weight_for"
                    label="Weight For"
                    rules={[
                      {
                        required: true,
                        message: 'Please select weight for',
                      },
                    ]}
                  >
                    <AutoOpenSelect
                      placeholder="Weight For"
                      onChange={handleWeightForOptionChange}
                      onSearch={handleSearchWeightFor}
                      showSearch={true}
                      value={selectedWeightForOption}
                      allowClear
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    >
                      {[
                        ...new Map(
                          weightForType.map(item => [item.id, item]),
                        ).values(),
                      ].map((el, index) => (
                        <Option key={el.id} value={el.id}>
                          {el.name}
                        </Option>
                      ))}
                    </AutoOpenSelect>
                  </Form.Item>
                </Col>
            <Col xs={12} sm={8} xl={6} xxl={3}>
                  <Form.Item
                    name="weight_automatic"
                    label="Weight Automatic"
                    rules={[
                      {
                        required: true,
                        message: 'Please select weight automatic or not',
                      },
                    ]}
                  >
                    <AutoOpenSelect
                      placeholder="Weight Automatic"
                      onChange={handleWeightAutomaticOptionChange}
                      onSearch={handleSearchWeightAutomatic}
                      showSearch={true}
                      value={selectedWeightAutomaticOption}
                      allowClear
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    >
                      {[
                        ...new Map(
                            weightAutomaticType.map(item => [item.id, item]),
                        ).values(),
                      ].map((el, index) => (
                        <Option key={el.id} value={el.id}>
                          {el.name}
                        </Option>
                      ))}
                    </AutoOpenSelect>
                  </Form.Item>
                </Col>
                {selectedWeightAutomaticOption === 'No' &&
                <Col xs={12} sm={8} xl={6} xxl={3}>
                <Form.Item
                  label="Enter Weight"
                  name="weight"
                  rules={[
                    { required: true, message: 'Please enter weight' },
                    // {
                    //   pattern: /^\d*\.?\d*$/,
                    //   message: 'Please enter only digits & decimal.',
                    // },
                    createNumberValidationRule({
                      allowNegative: false,
                      maxBeforeDecimal: 10, // Set max before decimal
                      maxAfterDecimal: 3, // Set max after decimal
                      allowDecimal: true,
                      allowZero: true,
                    }),
                  ]}
                >
                  <Input placeholder="Weight" maxLength={15} />
                </Form.Item>
              </Col>}
                <Col xs={12} sm={8} xl={6} xxl={3}>
                <Form.Item
                  label="Gross Weight"
                  name="gross_weight"
                  rules={[
                    { required: true, message: 'Please enter gross weight' },
                    // {
                    //   pattern: /^\d*\.?\d*$/,
                    //   message: 'Please enter only digits & decimal.',
                    // },
                    createNumberValidationRule({
                      allowNegative: false,
                      maxBeforeDecimal: 10, // Set max before decimal
                      maxAfterDecimal: 3, // Set max after decimal
                      allowDecimal: true,
                      allowZero: true,
                    }),
                  ]}
                >
                  <Input placeholder="Gross Weight" maxLength={15} />
                </Form.Item>
              </Col>
                <Col xs={12} sm={8} xl={6} xxl={3}>
                <Form.Item
                  label="Tare Weight"
                  name="tare_weight"
                  rules={[
                    { required: true, message: 'Please enter tare weight' },
                    // {
                    //   pattern: /^\d*\.?\d*$/,
                    //   message: 'Please enter only digits & decimal.',
                    // },
                    createNumberValidationRule({
                      allowNegative: false,
                      maxBeforeDecimal: 10, // Set max before decimal
                      maxAfterDecimal: 3, // Set max after decimal
                      allowDecimal: true,
                      allowZero: true,
                    }),
                  ]}
                >
                  <Input placeholder="Tare Weight" maxLength={15} />
                </Form.Item>
              </Col>
                <Col xs={12} sm={8} xl={6} xxl={3}>
                <Form.Item
                  label="Net Weight"
                  name="net_weight"
                  rules={[
                    { required: true, message: 'Please enter net weight' },
                    // {
                    //   pattern: /^\d*\.?\d*$/,
                    //   message: 'Please enter only digits & decimal.',
                    // },
                    createNumberValidationRule({
                      allowNegative: false,
                      maxBeforeDecimal: 10, // Set max before decimal
                      maxAfterDecimal: 3, // Set max after decimal
                      allowDecimal: true,
                      allowZero: true,
                    }),
                  ]}
                >
                  <Input placeholder="Net Weight" maxLength={15} />
                </Form.Item>
              </Col>
            
                {/* <Col xs={12} sm={8} xl={6} xxl={3}>
                <Form.Item
                  label="Serial No."
                  name="serial_no"
                  rules={[
                    { required: true, message: 'Please enter serial_no' },
                    // {
                    //   pattern: /^\d*\.?\d*$/,
                    //   message: 'Please enter only digits & decimal.',
                    // },
                    createNumberValidationRule({
                      allowNegative: false,
                      maxBeforeDecimal: 10, // Set max before decimal
                      maxAfterDecimal: 3, // Set max after decimal
                      allowDecimal: true,
                      allowZero: true,
                    }),
                  ]}
                >
                  <Input placeholder="Serial No." maxLength={15} />
                </Form.Item>
              </Col> */}
         <Col xs={12} sm={6} xl={4}>
  <Form.Item
    name="start_date"
    label="Date & Time First"
    rules={[
      { required: true, message: 'Please select date and time' },
    ]}
  >
    <DatePicker
      showTime={{ use12Hours: true, format: 'hh:mm A' }} 
      format="DD-MM-YYYY hh:mm A"                        
      style={{ width: '100%' }}
    />
  </Form.Item>
</Col>

<Col xs={12} sm={6} xl={4}>
  <Form.Item
    name="end_date"
    label="Date & Time Second"
    rules={[
      { required: true, message: 'Please select date and time' },
    ]}
  >
    <DatePicker
      showTime={{ use12Hours: true, format: 'hh:mm A' }} 
      format="DD-MM-YYYY hh:mm A"                        
      style={{ width: '100%' }}
    />
  </Form.Item>
</Col>

                 <Col xs={12} sm={8} xl={6} xxl={3}>
            
            <Form.Item
              label="Mound"
              name="mound"
              rules={[
                { required: true, message: 'Please enter mound' },
              ]}
            >
              <Input placeholder="Enter Mound"  />
            </Form.Item>
          </Col>
                  <Col xs={12} sm={8} xl={6} xxl={3}>
              
                  <Form.Item
              label="Serial No."
              name="serial_no"
              rules={[
                { required: true, message: 'Please enter serial no.' },
              ]}
            >
              <Input placeholder="Enter Serial No."  />
            </Form.Item>
            </Col>
            <Col xs={12} sm={8} xl={6} xxl={3}>
                  <Form.Item
                    name="total_copy"
                    label="Total Copy"
                    rules={[
                      {
                        required: true,
                        message: 'Please select total copy',
                      },
                    ]}
                  >
                    <AutoOpenSelect
                      placeholder="Total Copy"
                      onChange={handleTotalCopyChange}
                      onSearch={handleSearchTotalCopy}
                      showSearch={true}
                      value={selectedTotalCopy}
                      allowClear
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    >
                      {[
                        ...new Map(
                            totalCopyList.map(item => [item.id, item]),
                        ).values(),
                      ].map((el, index) => (
                        <Option key={el.id} value={el.id}>
                          {el.name}
                        </Option>
                      ))}
                    </AutoOpenSelect>
                  </Form.Item>
                </Col>
            <Col xs={12} sm={8} xl={6} xxl={3}>
              
            <Form.Item
              label="Vehicle No."
              name="vehicle_no"
              rules={[
                { required: true, message: 'Please enter vehicle no.' },
              ]}
            >
              <Input placeholder="Enter Vehicle No."  />
            </Form.Item>
            </Col>
          <Col xs={12} sm={8} xl={6} xxl={3}>
              
          <Form.Item
                label="Vehicle type"
                name="vehicle_type"
                rules={[
                  { required: true, message: 'Please select a vehicle type' },
                ]}
              >
                <AutoOpenSelect
                  placeholder="Select Vehicle Type"
                  style={{ width: '100%' }}
                  onChange={handleVehicleTypeChange}
                  // open={forceOpen || undefined}
                  labelInValue={true}
                  loading={vehicleTypeLoading}
                  onPopupScroll={onScrollVehicleType}
                  onClear={handleClearVehicleType}
                
                  // value={searchVehicleType}
                  value={searchVehicleType ? { value: searchVehicleType } : undefined}
                  notFoundContent={vehicleTypeLoading ? <Spin size="small" /> : 'No options'}
                  showSearch
                  // onSearch={handleSearchVehicleType}
                  onSearch={debounceVehicleTypeSearch}
                  allowClear
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  className={getClassNameVehicleType()}
                  dropdownRender={menu => (
                    <>
                      {vehicleTypeLoading ? (
                        <div style={{ padding: '16px', textAlign: 'center' }}>
                          <Spin size="small" />
                        </div>
                      ) : (
                        menu
                      )}
                    </>
                  )}
                >
                  {vehicleTypeLoading
                    ? [
                      <Option key="loading" disabled>
                        Loading...
                      </Option>,
                    ]
                    : [
                      ...new Map(
                        vehicleTypeDropdown.map(item => [item.id, item]),
                      ).values(),
                    ].map((el, index) => (
                      <Option
                        key={el.id}
                        value={el.id}
                        disabled={el.deleted === 1}
                      >
                        {el.vehicle_type}
                      </Option>
                    ))}
                </AutoOpenSelect>
              </Form.Item>
            </Col>
          <Col xs={12} sm={8} xl={6} xxl={3}>
              
          <Form.Item
                label="Party Name"
                name="party_name"
                rules={[
                  { required: true, message: 'Please select a party name' },
                ]}
              >
                <AutoOpenSelect
                  placeholder="Select Party Name"
                  style={{ width: '100%' }}
                  onChange={handlePartyNameChange}
                  // open={forceOpen || undefined}
                  labelInValue={true}
                  loading={partyNameLoading}
                  onPopupScroll={onScrollPartyName}
                  onClear={handleClearPartyName}
                
                  // value={searchVehicleType}
                  value={searchPartyName ? { value: searchPartyName } : undefined}
                  notFoundContent={partyNameLoading ? <Spin size="small" /> : 'No options'}
                  showSearch
                  // onSearch={handleSearchVehicleType}
                  onSearch={debouncePartyNameSearch}
                  allowClear
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  className={getClassNamePartyName()}
                  dropdownRender={menu => (
                    <>
                      {partyNameLoading ? (
                        <div style={{ padding: '16px', textAlign: 'center' }}>
                          <Spin size="small" />
                        </div>
                      ) : (
                        menu
                      )}
                    </>
                  )}
                >
                  {partyNameLoading
                    ? [
                      <Option key="loading" disabled>
                        Loading...
                      </Option>,
                    ]
                    : [
                      ...new Map(
                        partyNameDropdown.map(item => [item.id, item]),
                      ).values(),
                    ].map((el, index) => (
                      <Option
                        key={el.id}
                        value={el.id}
                        disabled={el.deleted === 1}
                      >
                        {el.party_name}
                      </Option>
                    ))}
                </AutoOpenSelect>
              </Form.Item>
            </Col>
              <Col xs={12} sm={8} xl={6} xxl={3}>
            
            <Form.Item
              label="Cash Party Name"
              name="cash_party_name"
              rules={[
                { required: true, message: 'Please enter cash party name' },
              ]}
            >
              <Input placeholder="Enter Cash Party Name"  />
            </Form.Item>
          </Col>
          <Col xs={12} sm={8} xl={6} xxl={4}>
              <Form.Item
                    label="Party Mobile No."
                    name="party_mobile_no"
                    rules={[
                      {
                        required: true,
                        message: 'Please input your party mobile number!',
                      },
                    ]}
                  >
                    <PhoneInput
                      country={'in'} // Default country (India)
                      enableSearch={true} // Enable searching for countries
                      placeholder="Enter party mobile number"
                    />
                  </Form.Item>
              </Col>
              <Col xs={12} sm={8} xl={6} xxl={3}>
              
              <Form.Item
                label="Material"
                name="material"
                rules={[
                  { required: true, message: 'Please select a material' },
                ]}
              >
                <Select
                  placeholder="Select Material"
                  style={{ width: '100%' }}
                  onChange={handleMaterialChange}
                  // open={forceOpen || undefined}
                  labelInValue={true}
                  loading={materialLoading}
                  onPopupScroll={onScrollMaterial}
                  onClear={handleClearMaterial}
                
                  // value={searchVehicleType}
                  value={searchMaterial ? { value: searchMaterial } : undefined}
                  notFoundContent={materialLoading ? <Spin size="small" /> : 'No options'}
                  showSearch
                  // onSearch={handleSearchVehicleType}
                  onSearch={debounceMaterialSearch}
                  allowClear
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  className={getClassNameMaterial()}
                  // dropdownRender={menu => (
                  //   <>
                  //     {materialLoading ? (
                  //       <div style={{ padding: '16px', textAlign: 'center' }}>
                  //         <Spin size="small" />
                  //       </div>
                  //     ) : (
                  //       menu
                  //     )}
                  //   </>
                  // )}
                >
                  {/* {materialLoading
                    ? [
                      <Option key="loading" disabled>
                        Loading...
                      </Option>,
                    ]
                    : [
                      ...new Map(
                        materialDropdown.map(item => [item.id, item]),
                      ).values(),
                    ].map((el, index) => (
                      <Option
                        key={el.id}
                        value={el.id}
                        disabled={el.deleted === 1}
                      >
                        {el.material_name}
                      </Option>
                    ))} */}
                        {materialDropdown?.map(el => (
                <Option key={el.id} value={el.id}
                  disabled={el.deleted === 1}>
                  {el.material_name}
                </Option>
              ))}
                </Select>
              </Form.Item>
            </Col>
              <Col xs={12} sm={8} xl={6} xxl={3}>
              
              <Form.Item
                label="Purchaser"
                name="purchaser"
                rules={[
                  { required: true, message: 'Please select a material' },
                ]}
              >
                <Select
                  placeholder="Select Purchaser"
                  style={{ width: '100%' }}
                  onChange={handlePurchaserChange}
                  // open={forceOpen || undefined}
                  labelInValue={true}
                  loading={purchaserLoading}
                  onPopupScroll={onScrollPurchaser}
                  onClear={handleClearPurchaser}
                
                  // value={searchVehicleType}
                  value={searchPurchaser ? { value: searchPurchaser } : undefined}
                  notFoundContent={purchaserLoading ? <Spin size="small" /> : 'No options'}
                  showSearch
                  // onSearch={handleSearchVehicleType}
                  onSearch={debouncePurchaserSearch}
                  allowClear
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  className={getClassNamePurchaser()}
                  // dropdownRender={menu => (
                  //   <>
                  //     {materialLoading ? (
                  //       <div style={{ padding: '16px', textAlign: 'center' }}>
                  //         <Spin size="small" />
                  //       </div>
                  //     ) : (
                  //       menu
                  //     )}
                  //   </>
                  // )}
                >
                  {/* {materialLoading
                    ? [
                      <Option key="loading" disabled>
                        Loading...
                      </Option>,
                    ]
                    : [
                      ...new Map(
                        materialDropdown.map(item => [item.id, item]),
                      ).values(),
                    ].map((el, index) => (
                      <Option
                        key={el.id}
                        value={el.id}
                        disabled={el.deleted === 1}
                      >
                        {el.material_name}
                      </Option>
                    ))} */}
                        {purchaserDropdown?.map(el => (
                <Option key={el.id} value={el.id}
                  disabled={el.deleted === 1}>
                  {el.name}
                </Option>
              ))}
                </Select>
              </Form.Item>
            </Col>
              <Col xs={12} sm={8} xl={6} xxl={3}>
              
              <Form.Item
                label="Seller"
                name="seller"
                rules={[
                  { required: true, message: 'Please select a seller' },
                ]}
              >
                <Select
                  placeholder="Select Seller"
                  style={{ width: '100%' }}
                  onChange={handleSellerChange}
                  // open={forceOpen || undefined}
                  labelInValue={true}
                  loading={sellerLoading}
                  onPopupScroll={onScrollSeller}
                  onClear={handleClearSeller}
                
                  // value={searchVehicleType}
                  value={searchSeller ? { value: searchSeller } : undefined}
                  notFoundContent={sellerLoading ? <Spin size="small" /> : 'No options'}
                  showSearch
                  // onSearch={handleSearchVehicleType}
                  onSearch={debounceSellerSearch}
                  allowClear
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  className={getClassNameSeller()}
                  // dropdownRender={menu => (
                  //   <>
                  //     {materialLoading ? (
                  //       <div style={{ padding: '16px', textAlign: 'center' }}>
                  //         <Spin size="small" />
                  //       </div>
                  //     ) : (
                  //       menu
                  //     )}
                  //   </>
                  // )}
                >
                  {/* {materialLoading
                    ? [
                      <Option key="loading" disabled>
                        Loading...
                      </Option>,
                    ]
                    : [
                      ...new Map(
                        materialDropdown.map(item => [item.id, item]),
                      ).values(),
                    ].map((el, index) => (
                      <Option
                        key={el.id}
                        value={el.id}
                        disabled={el.deleted === 1}
                      >
                        {el.material_name}
                      </Option>
                    ))} */}
                        {sellerDropdown?.map(el => (
                <Option key={el.id} value={el.id}
                  disabled={el.deleted === 1}>
                  {el.name}
                </Option>
              ))}
                </Select>
              </Form.Item>
            </Col>

                  
            <Col xs={24} sm={12} xl={8}>
            <Form.Item
              label="Capture Image"
              name="captured_image"
              valuePropName="image"
            >
              <CameraCapture
                onCapture={(imageSrc) => form.setFieldValue("captured_image", imageSrc)}
              />
            </Form.Item>
          </Col>

           


            </Row>
          </div>
       
          <div className="flex justify-end">
            <Form.Item className="mb-0">
              <Button
                type="primary"
                htmlType="submit"
                loading={btnLoading}
                icon={<PlusOutlined />}
              >
                Edit First Weight Entry
              </Button>
            </Form.Item>
          </div>
        </Form>
      </div>
    </>
  );
}

export default EditFirstWeightEntry;
